// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Form, FormGroup, Row, Col, FormControl, Button, ControlLabel, Clearfix, Alert, Checkbox } from 'react-bootstrap'
import { printableJsonError } from '../utils/enUtils.js'
import config from '../config/config.json'

export class PasswordReset extends Component {
    constructor() {
        super()

        this.state = {
            formAlertType: 'danger',
            formAlertDisplay: 'none',
            formAlertText: '',
            showPassword: false
        }

        this.handleShowPassword = this.handleShowPassword.bind(this)
        this.handleOnSubmit = this.handleOnSubmit.bind(this)
        this.resetPasswordByApi = this.resetPasswordByApi.bind(this)
        this.handleOnChangePassword = this.handleOnChangePassword.bind(this)
    }

    formAlertUpdate(type, display, text) {
        this.setState({
            formAlertType: type,
            formAlertDisplay: display,
            formAlertText: text
        })
    }

    handleShowPassword(e) {
        this.setState({
            showPassword: e.target.checked
        })
    }

    handleOnChangePassword(e) {
        this.clearFormAlert()
    }

    clearFormAlert() {
        this.formAlertUpdate('danger', 'none', '')
    }

    /**
     *  This function handles the submission of the Forgot Password form.
     */
    handleOnSubmit(e) {
        e.preventDefault()

        let formData = {
            token: this.props.location.query.token,
            password: this.newPasswordInput.value
        }

        if (this.isValidInput(formData)) {
            this.resetPasswordByApi(formData)
        }
    }

    isValidInput(formData) {
        if (!formData.token) {
            alert("Invalid reset token")
        } else if (!formData.password) {
            alert("Please enter a password")
        } else {
            return true;
        }

        return false;
    }

    resetPasswordByApi(data) {
        fetch(config[this.props.env] + config.api.update_password.endpoint, {
            method: config.api.update_password.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                reset_token: data.token,
                new_password: data.password
            })
        }).then((response) => response.json())
            .then((responseJson) => {
                let errorMessage = ""

                if ('errors' in responseJson) {
                    errorMessage = printableJsonError(responseJson.errors)
                    this.formAlertUpdate('danger', 'block', errorMessage)
                } else if ('error' in responseJson) {
                    errorMessage = printableJsonError(responseJson.error)
                    this.formAlertUpdate('danger', 'block', errorMessage)
                } else if (responseJson.message === 'password updated') {
                    this.formAlertUpdate('success', 'block', 'Your password has been updated successfully!')
                    setTimeout(() => { this.props.router.push('/login') }, 2000)
                } else {
                    this.formAlertUpdate('warning', 'block', responseJson.message)
                }
            })
            .catch((error) => {
                console.error(error)
            })
    }

    render() {
        return (
            <div className="forgot-password-container page-container">
                <div className="banner">
                    <Col smOffset={2} sm={8}>
                        <h2 className="title">Reset Password</h2>
                    </Col>
                    <Clearfix />
                </div>
                <Row>
                    <Col sm={12}>
                        <Alert bsStyle={this.state.formAlertType} style={{ display: this.state.formAlertDisplay }} onDismiss={this.handleAlertDismiss}>
                            <h3>{this.state.formAlertType === 'danger' ? "Error" : "Success"}</h3>
                            <p className="alert-text">{this.state.formAlertText}</p>
                        </Alert>
                    </Col>
                </Row>
                <Form horizontal className="reset-password-form">
                    <FormGroup controlId="formHorizontalPassword">
                        <Col componentClass={ControlLabel} sm={4}>
                            New Password
                        </Col>
                        <Col sm={5}>
                            <FormControl type={this.state.showPassword ? "text" : "password"} placeholder="New Password" inputRef={ref => { this.newPasswordInput = ref }} onChange={this.handleOnChangePassword} />
                            <FormControl.Feedback />
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="formHorizontalShowPassword">
                        <Col smOffset={4} sm={5}>
                            <Checkbox onChange={this.handleShowPassword} >
                                Show Password
                            </Checkbox>
                        </Col>
                    </FormGroup>
                    <hr className="invisible post-form" />
                    <FormGroup>
                        <Col smOffset={4} sm={5}>
                            <Button type="submit" bsStyle="primary" onClick={this.handleOnSubmit} >
                                Reset Password
                            </Button>
                        </Col>
                        <Col sm={2}>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/passwordReset.js